import React from 'react'
import './Experience.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import {
  SiSpringboot, SiDocker, SiReact, SiNodedotjs, SiVuedotjs, SiMysql,
  SiFlutter, SiMongodb, SiPostgresql, SiAngular, SiPhp,
  SiExpress, SiGit, SiFigma, SiCamunda, SiGooglegemini, SiPython,
} from 'react-icons/si'
import { FaJava, FaBrain, FaLanguage, FaNetworkWired } from 'react-icons/fa'
import Reveal from '../motion/Reveal'

// All skills rendered as colored glyph badges (no raster logo assets).
const skills = [
  { Icon: SiSpringboot, label: 'Spring Boot', color: '#6DB33F' },
  { Icon: SiDocker, label: 'Docker', color: '#2496ED' },
  { Icon: FaJava, label: 'Java', color: '#f89820' },
  { Icon: SiReact, label: 'React', color: '#61DAFB' },
  { Icon: SiNodedotjs, label: 'Node.js', color: '#339933' },
  { Icon: SiVuedotjs, label: 'Vue.js', color: '#4FC08D' },
  { Icon: SiMysql, label: 'MySQL', color: '#4479A1' },
  { Icon: SiFlutter, label: 'Flutter', color: '#02569B' },
  { Icon: SiMongodb, label: 'MongoDB', color: '#47A248' },
  { Icon: SiPostgresql, label: 'PostgreSQL', color: '#4169E1' },
  { Icon: SiAngular, label: 'Angular', color: '#DD0031' },
  { Icon: SiPhp, label: 'PHP', color: '#777BB4' },
  { Icon: SiExpress, label: 'Express.js', color: 'var(--heading-color)' },
  { Icon: SiGit, label: 'Git', color: '#F05032' },
  { Icon: SiFigma, label: 'Figma', color: '#F24E1E' },
  { Icon: SiCamunda, label: 'Camunda', color: '#FC5D0D' },
  { Icon: SiGooglegemini, label: 'Gemini AI', color: '#8E75B2' },
  { Icon: SiPython, label: 'Python', color: '#3776AB' },
  { Icon: FaBrain, label: 'LLM', color: '#4F46E5' },
  { Icon: FaLanguage, label: 'NLP', color: '#14B8A6' },
  { Icon: FaNetworkWired, label: 'RAG', color: '#F59E0B' },
]

const Experience = () => {
    return (
        <Reveal as="section" id='experience'>
            <h5 className='title'>What Technologies I Use?</h5>
            <h2>Skills</h2>
             <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={20}
                slidesPerView={5}
                navigation
                pagination={{ clickable: true }}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                breakpoints={{
                    320:  { slidesPerView: 2 },
                    640:  { slidesPerView: 3 },
                    1024: { slidesPerView: 5 },
                }}
            >
                {skills.map(({ Icon, label, color }) => (
                    <SwiperSlide key={label}>
                        <div className="skill-icon" style={{ '--skill-color': color }}>
                            <Icon className="skill-icon__glyph" />
                            <span className="skill-icon__label">{label}</span>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Reveal>
    )
}

export default Experience
